import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';

function NotFound() {
  return (
    <div className="app-container">
      <Header />
      
      <div className="main-content" style={{ textAlign: 'center', padding: '2rem' }}>
        <h1 style={{ color: '#009932', marginBottom: '1rem' }}>Error 404: Page Not Found</h1>
        <p style={{ marginBottom: '2rem' }}>The page you're looking for doesn't exist.</p>
        <Link to="/" className="btn btn-primary">Go to Home Page</Link>
      </div>

      <Footer />
    </div>
  );
}

export default NotFound;
